import LikeWidget from './widgets/like-widget.js';
import ViewCounter from './widgets/view-counter.js';

// Web Components
import './components/scroll-top-button.js';
import './components/footer-banner.js';
import './components/logo-tagline.js';
import './components/burger-menu.js';
import './components/like-button.js';
import './components/glossary.js';
import './components/word-combinations.js';
import './components/email-hider.js';
import './components/post-card.js';
import './components/contact-form.js';
import './components/random-post-link.js';
import './components/rating-widget.js';
import './components/related-posts.js';
import './components/poll.js';
import './components/daily-news-ticker.js';
import './components/arschkarte-game.js';
import './components/saying-of-the-day.js';

window.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded');
});

let widgetList = [];

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.like-widget')
    .forEach(element => {
      const widget = new LikeWidget(element, {
        // options can be passed here if needed
      });
      widgetList.push(widget);
    });

  document
    .querySelectorAll('[data-view-counter]')
    .forEach(element => {
      new ViewCounter(element);
    });

});